<med-label
  [label]="label"
  [name]="name"
  [disabled]="disabled"
  [required]="required"
  [labelClass]="labelClass"
>
  <div [ngClass]="{ field__container: hasErrorPadding }">
    <label
      [attr.for]="name"
      class="med-upload-file"
    >
      <input
        #inputRef
        hidden
        type="file"
        [id]="name"
        [name]="name"
        [disabled]="disabled"
        [required]="required"
        [accept]="accept"
        (change)="uploadFile($event)"
      />

      <div
        [ngClass]="classList"
        class="field med-upload-file__input"
      >
        <div class="med-upload-file__title">
          {{ fileName || placeholder }}
        </div>

        <div class="med-upload-file__nav">
          <med-icon-download
            size="14"
            *ngIf="!status"
            class="med-upload-file__icon"
          ></med-icon-download>

          <med-icon-pulse
            size="14"
            *ngIf="status === UPLOAD_STATUSES.PROGRESS"
            class="med-upload-file__icon"
          ></med-icon-pulse>

          <med-icon-x
            *ngIf="status === UPLOAD_STATUSES.DONE && !disabled && !hideClearBtn"
            size="14"
            class="med-upload-file__icon med-upload-file__icon--delete"
            (click)="clear($event)"
          ></med-icon-x>

          <div
            *ngIf="status === UPLOAD_STATUSES.DONE"
            class="med-upload-file__format"
          >
            .{{ type }}
          </div>
        </div>
      </div>
    </label>
  </div>

  <div
    *ngIf="invalid"
    class="field__error-message up"
  >
    {{ errorMessage }}
  </div>
</med-label>
